import React from "react";

export default function Title() {
  return (
    <div className="mt-16">
      <div className=" flex ">
        <h1 className=" text-transparent leading-snug  font-Main md:text-6xl lg:text-9xl text-start text-5xl  bg-clip-text bg-gradient-to-r from-purple-100 to-white ">
          Good Films Make Your Life Better
        </h1>
      </div>
    </div>
  );
}
